import { DropdownMenuOption } from '@ardoq/dropdown-menu-ui';
import { ComponentType } from 'react';
import { NoticeProps } from 'react-select';
import { SelectOption } from '../../types';
import { t } from '@ardoq/i18n';
import { getI18nLocaleFromSelectProps } from './getI18nLocaleFromSelectProps';

export const NoOptionsMessage: ComponentType<
  NoticeProps<SelectOption<unknown>>
> = ({ selectProps: { inputValue, noOptionsMessage, ...rest } }) => {
  const i18nLocale = getI18nLocaleFromSelectProps(rest);
  return (
    <DropdownMenuOption
      label={
        noOptionsMessage
          ? noOptionsMessage({ inputValue })
          : t(i18nLocale, 'select:noOptions', 'No options')
      }
      align="center"
    />
  );
};
